import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		authorization: localStorage.getItem("AESC_AUTH_TOKEN"),
		refresh: localStorage.getItem("AESC_REFRESH_TOKEN"),
		login: JSON.parse(localStorage.getItem("AESC_LOGIN") || '{}'),
		agreed: JSON.parse(localStorage.getItem("BSDB_AGREED") || 'false'),
		context: undefined,
		flaggedProfiles: JSON.parse(localStorage.getItem("BSDB_FLAGGED_PROFILES") || '{}'),
		hideCompensation: JSON.parse(localStorage.getItem("BSDB_COMP") || 'false'),
		queryId: null,
		query: JSON.parse(localStorage.getItem("BSDB_QUERY") || 'null'),
		searchResult: JSON.parse(localStorage.getItem("BSDB_SEARCH") || "{}"),
		currency: JSON.parse(localStorage.getItem("BSDBCurrency") || '{"Id":83,"Code":"USD","Symbol":"$"}'),
		currencyRange: JSON.parse(localStorage.getItem("BSDBCurrencyRange") || '[]'),
		xrate: parseFloat(localStorage.getItem("BSDBCurrencyRate") || '1'),
		searching: false,
		total: undefined
	},
	mutations: {
		SET_AUTH(state, params) {
			if (!params) {
				localStorage.removeItem("AESC_AUTH_TOKEN");
				localStorage.removeItem("AESC_REFRESH_TOKEN");
				localStorage.removeItem("BSDB_FV_PROFILES");
				localStorage.removeItem("BSDB_AGREED");
				state.authorization = null;
				state.refresh = null;
				localStorage.removeItem("AESC_LOGIN");
				state.login = null;
			} else {
				if (params.tokens) {
					state.authorization = params.tokens.authorization;
					delete params.tokens;
				}
				state.login = params;
			}
		},
		SET_CONTEXT(state, context) {
			state.context = context;
		},
		SET_FLAGGED(state, profiles) {
			state.flaggedProfiles = profiles;
		},
		SET_AGREED(state, params) {
			state.agreed = params.agreed;
			state.hideCompensation = params.compensation;
		},
		SET_QUERYID(state, params) {
			state.queryId = params;
		},
		SET_QUERY(state, params) {
			state.query = params;
		},
		SET_SEARCH(state, params) {
			state.searchResult = params;
		},
		SET_LOGIN(state, params) {
			state.login = params;
		},
		SET_TOTAL(state, params) {
			state.total = params;
		},
		SET_SEARCHING(state, params) {
			state.searching = params;
		},
		SET_CURRENCY(state, params) {
			state.currency = params;
		},
		SET_CURRENCYRANGE(state, params) {
			state.currencyRange = params;
		},
		SET_XRATE(state, params) {
			state.xrate = params;
		}
	},
	actions: {
		setFlaggedProfiles: ({ commit, state }, params) => {
			var profiles = params;
			localStorage.setItem("BSDB_FLAGGED_PROFILES", JSON.stringify(profiles));
			commit('SET_FLAGGED', profiles);
		},
		setSearchObject: ({ commit, state }, params) => {
			var search = params;
			localStorage.setItem("BSDB_SEARCH", JSON.stringify(search));
			commit('SET_SEARCH', search);
		},
		setAgreed: ({ commit, state }, params) => {
			document.cookie = "bsdbagreed=true'; domain='.aesc.org';path=/";
			localStorage.setItem("BSDB_COMP", JSON.stringify(params.compensation));
			commit("SET_AGREED", params);
		},
		setQueryId: ({ commit, state }, params) => {
			commit("SET_QUERYID", params);
		},
		setQuery: ({ commit, state }, params) => {
			localStorage.setItem("BSDB_QUERY", JSON.stringify(params));
			commit("SET_QUERY", params);
		},
		SetLogin: ({ commit, state }, params) => {
			localStorage.setItem("AESC_LOGIN", JSON.stringify(params));
			commit("SET_LOGIN", params);
		},
		setTotal: ({ commit, state }, params) => {
			commit("SET_TOTAL", params);
		},
		setSearching: ({ commit, state }, params) => {
			commit("SET_SEARCHING", params);
		},
		setCurrency: ({ commit, state }, params) => {
			localStorage.setItem("BSDBCurrency", JSON.stringify(params));
			commit("SET_CURRENCY", params);
		},
		setCurrencyRange: ({ commit, state }, params) => {
			localStorage.setItem("BSDBCurrencyRange", JSON.stringify(params));
			commit("SET_CURRENCYRANGE", params);
		},
		setXRate: ({ commit, state }, params) => {
			localStorage.setItem("BSDBCurrencyRate", params);
			commit("SET_XRATE", params);
		},
		refresh: ({ commit, state }, params) => {
			var login = params;
			localStorage.setItem("AESC_AUTH_TOKEN", login.tokens.authorization);
			localStorage.setItem("AESC_REFRESH_TOKEN", login.tokens.refresh);
			localStorage.setItem("AESC_LOGIN", JSON.stringify(login));

			commit('SET_AUTH', login);
			return login;
		},
	},
	getters: {
		queryId: state => {
			if (state.queryId) {
				return state.queryId;
			}
			else {
				return null;
			}
		},
		query: state => {
			if (state.query) {
				return state.query;
			}
			else {
				return null;
			}
		},
		emptyQuery: state => {
			return JSON.parse(JSON.stringify({
				Company: null,
				CompanySpan: {
					Current: true,
					Past: false
				},
				Country: [],
				CountrySpan: {
					Current: true,
					Seeking: false,
					Past: false
				},
				Function: [],
				FunctionSpan: {
					Current: true,
					Seeking: false,
					Past: false
				},
				Industry: [],
				IndustrySpan: {
					Current: true,
					Seeking: false,
					Past: false
				},
				Region: [],
				State: [],
				StateSpan: {
					Current: true,
					Seeking: false
				},
				Title: null,
				TitleSpan: {
					Current: true,
					Past: false,
				},
				Language: [],
				Gender: [],
				Compensation: [],
				Name: null,
			}));
		},
		hideCompensation: state => {
			if (state.hideCompensation != null) {
				return state.hideCompensation;
			} else {
				return false;
			}
		},
		showCompensation: state => {
			//Admins are always eligible
			if (state.login && state.login.user && state.login.user.Email && (state.login.user.Email.endsWith("@13prime.com") || state.login.user.Email.endsWith("@aesc.org")))
				return true;

			if (state.login && state.login.office) {
				return state.login.office.ShowCompensation;
			} else {
				return false;
			}
		},
		currency: state => {
			return state.currency;
		},
		currencyRange: state => {
			return state.currencyRange;
		},
		xrate: state => {
			return state.xrate;
		},
		total: state => {
			return state.total;
		},
		flagged: state => {
			return state.flaggedProfiles;
		},
		search: state => {
			if (state.searchResult.count) {
				return state.searchResult;
			}
			else {
				return null;
			}
		},
		agreed: state => {
			return state.agreed;
		},
		isAdmin: state => {
			if (state.login && state.login.user && state.login.user.Email) {
				if (state.login.user.Email.endsWith("@13prime.com") || state.login.user.Email.endsWith("@aesc.org"))
					return true;
				else
					return false;
			}
			else
				return false;
		},
		isSearching: state => {
			return state.searching;
		}
	},
	modules: {
	}
})
